module.exports = __webpack_public_path__ + "static/media/Team22.c232f3dd.PNG";